import { Observable } from 'rxjs';

export abstract class CheckoutBillingAdapter {
  abstract setBillingAddress(userId: string, cartId: string, billingAddressData: any): Observable<any>;
  abstract selectBillingAddress(userId: string, cartId: string, addressId: string): Observable<any>;
}
